import dict from '../data/dictionary.json';

import Shepherd from 'shepherd.js';
import { offset } from '@floating-ui/dom';

import { Sesion, Solr } from '../main.js';
import { getLiteral } from './util.js';
import { sendEvent } from './events.js';

function lanzarTour() {
	// marco como completado el tour para que no recargue todo el rato el tour
	localStorage.setItem('tourCompletado', true); // cuidado, que setItem sólo guarda strings
	
	// empieza tutorial
	sendEvent( 'tutorial_begin' );

	// creo tour
	const tour = new Shepherd.Tour({
		useModalOverlay: true,
		defaultStepOptions: {
			cancelIcon: { enabled: true },
			//classes: 'class-1 class-2',
		    scrollTo: { behavior: 'smooth', block: 'center' }
		}
	});
	// creo los pasos del tour
	//'Welcome',
	tour.addStep({
		title: getLiteral(dict.tourTitle0),
		text: getLiteral(dict.tourText0),
		buttons: [
			{
				text: getLiteral(dict.tourExit),
				classes: 'shepherd-button-secondary',
				action() {
					return this.complete();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action: tour.next
			}
		]
	});
	// "The map",
	tour.addStep({
		title: getLiteral(dict.tourTitle1),
		text: getLiteral(dict.tourText1),
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action: tour.next
			}
		]
	});
	//'Zoom',
	if (!L.Browser.mobile) {
		tour.addStep({
			title: getLiteral(dict.tourTitle2),
			text: getLiteral(dict.tourText2),
			classes: 'mb-3',
			attachTo: {
				element: '.leaflet-control-zoom',
				on: 'top'
			},
			floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action() {
						return this.next();
					}
				}
			]
		});
	}
	//'Mi localización',
	tour.addStep({
		title: getLiteral(dict.tourTitle3),
		text: getLiteral(dict.tourText3),
		classes: 'mb-3',
		attachTo: {
			element: '.leaflet-control-locate',
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'tour',
	tour.addStep({
		title: getLiteral(dict.tour),
		text: getLiteral(dict.tourText3a),
		classes: 'mb-3',
		attachTo: {
			element: '.tour',
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'Download data',
	tour.addStep({
		title: getLiteral(dict.tourTitle4),
		text: getLiteral(dict.tourText4),
		classes: 'mb-3',
		attachTo: {
			element: '.download',
		    on: 'top'
		},
		floatingUIOptions: { middleware: [offset({ mainAxis: 15, crossAxis: 0 })] },
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'Configura el mapa',
	tour.addStep({
		title: getLiteral(dict.tourTitle5),
		text: getLiteral(dict.tourText5),
		classes: 'mt-3',
		attachTo: {
			element: '.div-layers',
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	if (Solr) {
		//'Search places',	
		tour.addStep({
			title: getLiteral(dict.tourTitle6),
			text: getLiteral(dict.tourText6),
			classes: 'mt-3',
			attachTo: {
				element: '#toggle_lugares',
				on: 'bottom'
			},
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action() {
						return this.next();
					}
				}
			]
		});
	}
	//'Edición del IFN',
	tour.addStep({
		title: getLiteral(dict.tourTitle7),
		text: getLiteral(dict.tourText7),
		classes: 'mt-3',
		attachTo: {
			element: '.ifnradio',
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'Filter taxon',	
	tour.addStep({
		title: getLiteral(dict.tourTitle8),
		text: getLiteral(dict.tourText8),
		classes: 'mt-3',
		attachTo: {
			element: '#bot_taxones',
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'Scientific names',
	tour.addStep({
		title: getLiteral(dict.tourTitle9),
		text: getLiteral(dict.tourText9),
		classes: 'mt-3',
		attachTo: {
			element: '#bot_mapnomci',
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	//'More options',
	tour.addStep({
		title: getLiteral(dict.tourTitle10),
		text: getLiteral(dict.tourText10),
		classes: 'mt-3',
		attachTo: {
			element: '#bot_inicio',
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action() {
					return this.next();
				}
			}
		]
	});
	// "Configure a plot filter",
	if (Sesion.estado.plots) {
		const targetplot = Sesion.taxones.length == 0? '#filter-plantae' : '.tune_filter_taxon';
		console.log(targetplot);
		tour.addStep({
			title: getLiteral(dict.tourTitle11),
			text: getLiteral(dict.tourText11),
			classes: 'mt-3',
			attachTo: {
				element: targetplot,
				on: 'bottom'
			},
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action: tour.next
				}
			]
		});
	}	
	// "Taxon information"
	const targettx = Sesion.taxones.length == 0? '.info_taxon' : document.querySelectorAll('.info_taxon')[1];
	tour.addStep({
		title: getLiteral(dict.tourTitle12),
		text: getLiteral(dict.tourText12),
		classes: 'mt-3',
		attachTo: {
			element: targettx,
		    on: 'bottom'
		},
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourNext),
				action: tour.next
			}
		]
	});	
	// "taxon color"
	if (document.querySelector('.color_filtro')) {
		tour.addStep({
			title: getLiteral(dict.tourTitle13),
			text: getLiteral(dict.tourText13),
			classes: 'mt-3',
			attachTo: {
				element: '.color_filtro',
				on: 'bottom'
			},
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action: tour.next
				}
			]
		});
	}
	// "remove taxon"
	if (document.querySelector('.quitar_taxon')) {
		tour.addStep({
			title: getLiteral(dict.tourTitle14),
			text: getLiteral(dict.tourText14),
			classes: 'mt-3',
			attachTo: {
				element: '.quitar_taxon',
				on: 'top'
			},
			buttons: [
				{
					text: getLiteral(dict.tourBack),
					classes: 'shepherd-button-secondary',
					action() {
						return this.back();
					}
				}, 
				{
					text: getLiteral(dict.tourNext),
					action: tour.next
				}
			]
		});
	}	
	//'The end',
	tour.addStep({
		title: getLiteral(dict.tourTitle15),
		text: getLiteral(dict.tourText15),
		buttons: [
			{
				text: getLiteral(dict.tourBack),
				classes: 'shepherd-button-secondary',
				action() {
					return this.back();
				}
			}, 
			{
				text: getLiteral(dict.tourDone),
				action() {
					sendEvent( 'tutorial_complete' );
					return this.complete();
				}
			}
		]
	});	
	
	// lanzo...
	tour.start();
}

export { lanzarTour };